// eslint-disable-next-line import/prefer-default-export
import Vue from "vue";

export const parametersMutations = {
    SET_SHOW_DATE_SELECTOR: (state, payload) => {
        Vue.set(state, 'show_date_selector', payload);
    },
    
    SET_DATES_START: (state, payload) => {
        Vue.set(state.dates, 'start', payload);
    },
    
    SET_DATES_END: (state, payload) => {
        Vue.set(state.dates, 'end', payload);
    },

    SET_MAIN_CALENDAR_REFRESH: (state, payload) => {
        Vue.set(state, 'main_calendar_refresh', payload);
    },
    
    SET_AUDIT_DATES_START: (state, payload) => {
        Vue.set(state.audit_dates, 'start', payload);
    },
    
    SET_AUDIT_DATES_END: (state, payload) => {
        Vue.set(state.audit_dates, 'end', payload);
    },

    SET_EXPERT_DATES_START: (state, payload) => {
        Vue.set(state.expert_dates, 'start', payload);
    },

    SET_EXPERT_DATES_END: (state, payload) => {
        Vue.set(state.expert_dates, 'end', payload);
    },

    SET_EXPERT_CALENDAR_REFRESH: (state, payload) => {
        Vue.set(state, 'expert_calendar_refresh', payload);
    },

    SET_NIV2_DATES_START: (state, payload) => {
        Vue.set(state.niv2_dates, 'start', payload);
    },

    SET_NIV2_DATES_END: (state, payload) => {
        Vue.set(state.niv2_dates, 'end', payload);
    },

    SET_NIV2_CALENDAR_REFRESH: (state, payload) => {
        Vue.set(state, 'niv2_calendar_refresh', payload);
    },

    SET_INSTALLATIONS_GROUPS: (state, payload) => {
        Vue.set(state, 'installations_groups', payload);
    },
    
    INIT_DATES: (state) => {
        const today = new Date();
        Vue.set(state.dates, 'start', new Date(today.getFullYear(), today.getMonth()-1, today.getDay()).toISOString().split('T')[0])
        
        Vue.set(state.dates, 'end', today.toISOString().split('T')[0]);
    },
    
    SET_EXPERT_PDM: (state, payload) => {
        Vue.set(state, 'expert_pdm', payload);
    },

    SET_GEO_PDM: (state, payload) => {
        Vue.set(state, 'geo_pdm', payload);
    },

    SET_GEO_TIMESTEP: (state, payload) => {
        Vue.set(state, 'geo_timestep', payload);
    },
};
